// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  NetworkVirtualApplianceSku,
  VirtualApplianceSkusListOptionalParams,
  VirtualApplianceSkusGetOptionalParams,
  VirtualApplianceSkusGetResponse,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a VirtualApplianceSkus. */
export interface VirtualApplianceSkus {
  /**
   * List all SKUs available for a virtual appliance.
   * @param options The options parameters.
   */
  list(
    options?: VirtualApplianceSkusListOptionalParams,
  ): PagedAsyncIterableIterator<NetworkVirtualApplianceSku>;
  /**
   * Retrieves a single available sku for network virtual appliance.
   * @param skuName Name of the Sku.
   * @param options The options parameters.
   */
  get(
    skuName: string,
    options?: VirtualApplianceSkusGetOptionalParams,
  ): Promise<VirtualApplianceSkusGetResponse>;
}
